// Core Vue
import Vue from 'vue'
import routerBuilder from './router'
import storeBuilder from './store'
import commonComponents from './components'
import ftAPI from './plugins/ftAPI'
import VuePromptPlugin from './plugins/dialogs/vuePromptPlugin.js'
import VueKonva from 'vue-konva'
import vuetify from './plugins/vuetify'
import {lazyCoreLoading} from './util/helpers'

// App Css
import '@mdi/font/css/materialdesignicons.css'
import './css/ForeTeesIcons.css'
import './css/core.css'

// Discrete component lazy loaders
export const NoAccessLoader = lazyCoreLoading('NoAccess')
export const NotFoundLoader = lazyCoreLoading('NotFound')
export const MenuIndexLoader = lazyCoreLoading('MenuIndex')
export const EmptyLoader = lazyCoreLoading('Empty')
export const ClubSettingsListLoader = lazyCoreLoading('clubSettings/ClubSettingsList')

// Discrete component exports
export {default as CoreNavigation} from './components/CoreNavigation'
export {default as DetailEditorTable} from './components/DetailEditorTable'
export {default as MarkupEditor} from './components/MarkupEditor'
export {default as ReportBuilder} from './components/reportBuilder/ReportBuilder'
export {default as GuestSelect} from './components/GuestSelect'
export {default as LegacyIframe} from './components/LegacyIframe'

// Discrete mixin exports
export {default as apiHelpers} from './mixins/itemEditor/mixins/apiHelpers'
export {default as itemHelpers} from './mixins/itemEditor/mixins/itemHelpers'
export {default as rules} from './mixins/rules'
export {default as headerMethods} from './mixins/headerMethods'
export {default as errorHandler} from './mixins/errorHandler'
export {default as itemSelect} from './mixins/itemEditor/itemSelect'
export {default as itemEdit} from './mixins/itemEditor/itemEdit'
export {default as withChildren} from './mixins/withChildren'
export {default as navRoute} from './mixins/navRoute'
export {default as groupableReport} from './components/reportBuilder/mixins/groupable'

// Global utils
import * as helpers from './util/helpers'
import * as values from './util/values'
export {
  helpers,
  values
}

// App builder
export default function (config, env) {

  console.warn('Building App', config, env)

  // Disable production build warning
  Vue.config.productionTip = false

  // ForeTees API plugin
  Vue.use(ftAPI, config)

  /* "Vue Prompts" plugin (quick information dialogs without defining v-dialog) */
  Vue.use(VuePromptPlugin)

  // Konva canvassing library
  Vue.use(VueKonva)

  /* Components that are common enough to include globally (see ./components/index.js) */
  commonComponents.forEach(component => {
    Vue.component(component.name, component)
  })

  const router = routerBuilder(config)
  const store = storeBuilder(config)

  /* JIRA issue tracker(s) */
  // While we are including jQuery for use with Jira, *** DO NOT USE jQuery *** elsewhere!
  if (env.VUE_APP_JIRA_ISSUE_COLLECTOR) {
    const jQuery = require('jquery')
    window.jQuery = jQuery
    jQuery.ajax({
      url: env.VUE_APP_JIRA_ISSUE_COLLECTOR + '&collectorId=' + env.VUE_APP_JIRA_ISSUE_COLLECTOR_ID,
      type: 'get',
      cache: true,
      dataType: 'script'
    })
    const collectorOpts = {}
    collectorOpts[env.VUE_APP_JIRA_ISSUE_COLLECTOR_ID] = {
      triggerFunction: (showCollectorDialog) => {
        window.__ATL_showIssueCollectorDialog = showCollectorDialog
      }
    }
    window.ATL_JQ_PAGE_PROPS = jQuery.extend(window.ATL_JQ_PAGE_PROPS, collectorOpts)
  }

  /* Return Configured plugins */
  return {
    vuetify,
    router,
    store
  }

}

